import { render, staticRenderFns } from "./VueQrcode.vue?vue&type=template&id=7b82067c&"
import script from "./VueQrcode.vue?vue&type=script&lang=ts&"
export * from "./VueQrcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports